import { render } from "./OcrList.vue?vue&type=template&id=0b1a9f66"
import script from "./OcrList.vue?vue&type=script&lang=js"
export * from "./OcrList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__